<template>
  <div class="party-seats-table">
    <div class="party-seats-table__year-buttons">
      <div @click="onPartySeatsButtonClick(item)"
        v-for="(item, index) in dataKeys"
        :key="index"
        ref="item"
        class="party-seats-table__year-button"
        :class="{'party-seats-table__button-focus': item === focusYear}"
      >
        <div class="party-seats-table__wording">{{ item }}</div>
        <div class="party-seats-table__wording">席次<span v-if="item === '2020'">預估</span></div>
      </div>
    </div>

    <div class="party-seats-table__table">
      <div class="party-seats-table__table-layout">
        <div class="party-seats-table__table-head" :class="`party-seats-table__table-head--len-${dataLength}`">
          <div class="party-seats-table__col">政黨</div>
          <div class="party-seats-table__col">得票率</div>
          <div class="party-seats-table__col">席次</div>
          <div class="party-seats-table__col">補助款</div>
        </div>

        <div class="party-seats-table__table-body" :class="`party-seats-table__table-body--len-${dataLength}`">
          <div class="party-seats-table__body-row" :class="`party-seats-table__body-row--len-${dataLength}`" v-for="(item, index) in data[focusYear]" :key="index">
            <div class="party-seats-table__body-col" >{{ item.party }}</div>
            <div class="party-seats-table__body-col">{{ item.proportion.toFixed(2) }}%</div>
            <div class="party-seats-table__body-col">{{ item.seats }}</div>
            <div class="party-seats-table__body-col">
              <div class="party-seats-table__check-sign">
                <SvgSymbol :use="`#check-no`" v-if="!item.grants"/>
                <SvgSymbol :use="`#check-yes`" v-if="item.grants"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="party-seats-table__table-descs">
        <div class="party-seats-table__table-desc" v-for="note in notes" :key="note">
          <div class="party-seats-table__table-desc-mark"><!--
          --><SvgSymbol use="#arrow-down"/>
          </div>
          <span>{{ note }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PARTYSEATS_DATA from '@/data/legislator-seats-and-grants.json'

const PARTYSEATS_NOTES = {
  '2020': [
    '以聯合報 2019/12/10 民調結果，預測不分區立委席次。',
    '依《選罷法》若得票達法定門檻，政府將撥款補助政黨營運，一票50元，為期 4 年。2020 年補助款門檻為 3%。'
  ],
  '2016': [
    '依《選罷法》若得票達法定門檻，政府將撥款補助政黨營運，一票50元，為期 4 年。2016 年補助款門檻為 3.5%。'
  ],
  '2012': [
    '依《選罷法》若得票達法定門檻，政府將撥款補助政黨營運，一票50元，為期 4 年。2012 年補助款門檻為 5%。'
  ]
}

export default {
  name: 'PartySeatsTable',
  data () {
    return {
      data: PARTYSEATS_DATA,
      dataNotes: PARTYSEATS_NOTES,
      dataKeys: null,
      focusYear: 2020,
      isFocus: false,
      dataLength: 0
    }
  },
  computed: {
    notes () {
      return this.dataNotes[this.focusYear] || ''
    }
  },
  methods: {
    onPartySeatsButtonClick (item) {
      this.focusYear = item
      this.dataLength = this.data[item].length
      // console.log(this.focusYear)
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Click',
        'eventLabel': `Party-legislators-${this.focusYear}`
      })
    }
  },
  mounted () {
    this.dataKeys = Object.keys(this.data).reverse()
    this.onPartySeatsButtonClick(JSON.stringify(this.focusYear))
  }
}
</script>

<style lang="scss">
  .party-seats-table {
    user-select: none;

    @include rwd($RWD_DESKTOP) {
      margin: 0 auto;
      max-width: 1280px;
    }

    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 0 53px;
    }

    &__year-buttons {
      padding: 0 15px;
      text-align: center;

      @include rwd($RWD_TABLET_SMALL) {
        padding: 0 50px;
      }

      @include rwd($RWD_TABLET) {
        padding: 0 47px;
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        padding: 0;
      }
    }

    &__year-button {
      display: inline-block;
      width: 30%;
      margin-left: 3%;
      color: #ffffff;
      font-size: 0.875rem;
      line-height: 1.125rem;
      letter-spacing: 0.0875rem;
      border: 2px solid #dd6f6f;
      background-color: #e8a687;
      padding: 11px 0;
      vertical-align: top;
      cursor: pointer;

      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1rem;
        letter-spacing: 0.1rem;
      }

      @include rwd($RWD_TABLET) {
        width: 31%;
        margin-left: 2%;
        padding: 14px 0;
        font-size: 1.125rem;
        letter-spacing: 0.1125rem;
      }

      @include rwd($RWD_DESKTOP) {
        padding: 12px 0;
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        width: 244px;
      }
    }

    &__year-button:first-child {
      margin-left: 0;
    }

    &__button-focus {
      position: relative;
      padding: 14px 0;
      background-color: #dd6f6f;
      border-color: #dd6f6f;
      box-shadow: 0 4px#f6d18a;

      &::before {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -12px;
        margin-left: -16px;
        border-top: 8px solid #f6d18a;
        border-right: 16px solid transparent;
        border-left: 16px solid transparent;
      }

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -8px;
        margin-left: -16px;
        border-top: 8px solid #dd6f6f;
        border-right: 16px solid transparent;
        border-left: 16px solid transparent;
      }

      @include rwd($RWD_TABLET_SMALL) {
        padding: 10px 0 18px;
      }

      @include rwd($RWD_TABLET) {
        padding: 14px 0 22px;
      }

      @include rwd($RWD_DESKTOP) {
        padding: 12px 0 14px;
      }
    }

    &__wording {
      @include rwd($RWD_TABLET) {
        display: inline-block;
      }
    }

    &__table {
      margin: -40px 2px 0;

      @include rwd($RWD_TABLET_SMALL) {
        margin: -35px 25px 0;
      }

      @include rwd($RWD_TABLET) {
        margin: -20px 25px 0;
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        margin: -20px 0 0;
      }
    }

    &__table-layout {
      border: 2px solid #dd6f6f;
      background-color: #eeeeee;
      padding: 76px 12px 0;

      @include rwd($RWD_TABLET_SMALL) {
        padding: 64px 22px 0;
      }

      @include rwd($RWD_TABLET) {
        padding: 50px 24px 0;
      }

      @include rwd($RWD_DESKTOP) {
        padding: 35px 0 30px;
        height: 324px;
      }
    }

    &__table-head {
      padding-bottom: 20px;
      color: #dd6f6f;
      font-size: 0.875rem;
      font-weight: bold;
      letter-spacing: 0.0875rem;

      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1rem;
      }

      @include rwd($RWD_TABLET) {
        padding-bottom: 16px;
      }

      @include rwd($RWD_DESKTOP) {
        display: inline-block;
        width: 11.11%;
        height: 100%;
        padding: 24px 0 0;
        vertical-align: middle;
        border-right: 1px solid#e8a687;
      }

      &--len-6 {
        @include rwd($RWD_DESKTOP) {
          width: 14.28%;
        }
      }
    }

    &__col {
      display: inline-block;
      text-align: center;
      width: 23%;

      @include rwd($RWD_DESKTOP) {
        display: block;
        width: 100%;
        height: 25%;
      }
    }

    &__col:first-child {
      width: 31%;

      @include rwd($RWD_DESKTOP) {
        width: 100%;
      }
    }

    &__table-body {
      color: #1a1a1a;
      font-size: 0.875rem;
      font-weight: bold;
      letter-spacing: 0.0875rem;

      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1rem;
      }

      @include rwd($RWD_DESKTOP) {
        display: inline-block;
        width: 88.88%;
        height: 100%;
        text-align: center;
        vertical-align: middle;
      }

      &--len-6 {
        @include rwd($RWD_DESKTOP) {
          width: 85.72%;
        }
      }
    }

    &__body-row {
      padding: 16px 0;
      border-top: #dd6f6f 1px solid;

      @include rwd($RWD_DESKTOP) {
        display: inline-block;
        width: 12.5%;
        height: 100%;
        padding: 24px 0 0;
        border-color: transparent;
        border-left: #e8a687 1px solid;
      }

      &--len-6 {
        @include rwd($RWD_DESKTOP) {
          width: 16.66%;
        }
      }
    }

    &__body-row:first-child {
      @include rwd($RWD_DESKTOP) {
        border-left: none;
      }
    }

    &__body-col{
      position: relative;
      display: inline-block;
      width: 23%;
      text-align: center;
      vertical-align: middle;

      @include rwd($RWD_DESKTOP) {
        display: block;
        width: 100%;
        height: 25%;
      }
    }

    &__body-col:first-child {
      width: 31%;
      // padding: 0 15px;

      @include rwd($RWD_DESKTOP) {
        width: 100%;
      }
    }

    &__table-descs {
      position: relative;
      padding: 16px 8px 24px 25px;
      font-size: 0.8125rem;
      line-height: 0.875rem;
      letter-spacing: 0.08125rem;
      font-weight: 500;

      @include rwd($RWD_TABLET_SMALL) {
        padding: 16px 24px 24px 28px;
        font-size: 0.875rem;
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        padding: 16px 24px 24px 35px;
        font-size: 0.9375rem;
      }

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 180px;
        height: 0;
        margin-left: -90px;
        border-top: 1px solid #dd6f6f;
      }
    }

    &__table-desc {
      position: relative;
      line-height: 1.5rem;
    }

    &__table-desc-mark {
      display: block;
      position: absolute;
      left: -15px;
      top: 10px;
      width: 10px;
      height: 5px;
      color: black;
      transform: rotate(-90deg);
    }

    &__check-sign {
      position: relative;
      display: inline-block;
      width: 25px;
      height: 25px;
      vertical-align: bottom;
    }
  }
</style>
